"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchAvailableSlotsByDay = void 0;
const batchAvailableSlotsByDay = (availableSlots, filterBy) => {
    if (!availableSlots || availableSlots.length === 0) {
        return {};
    }
    const isFilteredByTimeOfDay = filterBy.timeOfDay.size > 0; // true
    const isFilteredByDayOfWeek = filterBy.dayOfWeek.size > 0; // true
    const groupedByDate = availableSlots
        .filter((slot) => {
        return ((!isFilteredByTimeOfDay || filterBy.timeOfDay.has(slot.time_of_day)) &&
            (!isFilteredByDayOfWeek || filterBy.dayOfWeek.has(slot.day_of_week)));
    })
        .reduce((acc, slot) => {
        const date = slot.start_datetime.split(' ')[0];
        if (!acc[date]) {
            acc[date] = [];
        }
        if (!acc[date].some((existingSlot) => existingSlot.start_datetime === slot.start_datetime)) {
            acc[date].push(slot);
        }
        return acc;
    }, {});
    Object.keys(groupedByDate).forEach((date) => {
        groupedByDate[date].sort((a, b) => new Date(a.start_datetime).getTime() -
            new Date(b.start_datetime).getTime());
    });
    return groupedByDate;
};
exports.batchAvailableSlotsByDay = batchAvailableSlotsByDay;
//# sourceMappingURL=ApptList.utils.js.map